"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPartParameterTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsExport = require("../DmsExport/DmsExport");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsPartParameterTable.
 * Renders a DmsTable with part parameter datas
 * @component
 * @example
 * return (
 *   <DmsPartParameterTable />
 * )
 */

const DmsPartParameterTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Minimum").d("Minimum"),
    column_name: "min",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Maximum").d("Maximum"),
    column_name: "max",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Unit").d("Unit"),
    column_name: "unit",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Sequence").d("Sequence"),
    column_name: "sequence",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    width: "5vw",
    sortable: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdatePartParameter", {
          name
        }).d("Update part parameter ".concat(name)),
        url: "/part_parameter",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeletePartParameter", {
          name
        }).d("Delete part parameter ".concat(name)),
        text: _reactIntlUniversal.default.get("PartParameter.DeleteMensage", {
          name
        }).d("Delete part parameter with name ".concat(name, ". Are you sure about it?")),
        url: "/part_parameter",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreatePartParameter").d("Create part parameter"),
    url: "/part_parameter",
    header: header,
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "part_parameter/table",
    responsive: true,
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }));
};
exports.DmsPartParameterTable = DmsPartParameterTable;